import { createPolymorphicComponent, UnstyledButton } from '@mantine/core';
import { forwardRef } from 'react';
import { UnstyledButtonType } from '../SearchBars/SearchFigma/types';
import Text, { TextProps } from './Text';

const _ButtonText = forwardRef<HTMLButtonElement, TextProps>((props, ref) => {
  return <Text {...props} ref={ref} component={UnstyledButton} />;
});
export const ButtonText = createPolymorphicComponent<
  UnstyledButtonType,
  TextProps
>(_ButtonText);
